import { useRef } from "react";

import { BadgeThemeProps } from "hardcover-ui/theme/components/badge";
import useBookMatchScore from "hooks/useBookMatchScore";
import useOnScreen from "hooks/useIsOnScreen";

import MatchPercentageBadge from "./MatchPercentageBadge";

interface BookMatchPercentageForUserType {
  bookId: number;
  size?: BadgeThemeProps["size"];
}

export default function BookMatchPercentageForUser({
  bookId,
  size = "sm",
}: BookMatchPercentageForUserType) {
  const ref = useRef(null);
  const isVisible = useOnScreen(ref, "200px");
  const score = useBookMatchScore({ bookId, isVisible });

  // No score available
  if (score === null) {
    return <></>;
  }

  // Loading the score
  if (score === undefined) {
    return <span ref={ref} className="invisible" />;
  }

  return <MatchPercentageBadge size={size} matchScore={score} />;
}
